import Vue from 'vue'
import Router from 'vue-router'
// import Basic from '../views/oms/orderManager/basic'
Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    no-catch:true      不缓存，切换路由不留存上次记录
  }
 **/
// export default new Router({

// })
export const constantRouterMap = [
  {path: '/login', component: () => import('@/views/login/index'), hidden: true,name: 'login',},
  {path: '/404', component: () => import('@/views/404'), hidden: true},
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {title: '首页', icon: 'home', affix: true }
    }]
  }

]

export const asyncRouterMap = [
         {
           path: "/own",
           name: "own",
           component: Layout,
           redirect: "dashboard",
           alwaysShow: true,
           meta: { title: "个人中心", icon: "" },
           children: [
             {
               path: "dashboard",
               component: () => import("@/views/own/dashboard/index"),
               name: "dashboard",
               meta: { title: "个人中心", icon: "dashboard" }
             },
             {
               path: "msgCenter",
               name: "msgCenter",
               component: () => import("@/views/own/msg/persistManage"),
               meta: { title: "我的消息", icon: "msgCenter" }
             },
             {
               path: "msgConfig",
               name: "msgConfig",
               component: () => import("@/views/own/msg/msgConfig"),
               meta: { title: "消息中心", icon: "msgConfig" }
             }
           ]
         },
         {
           path: "/ums",
           component: Layout,
           redirect: "/ums/admin",
           name: "ums",
           meta: { title: "权限", icon: "ums" },
           children: [
             {
               path: "admin",
               name: "admin",
               component: () => import("@/views/ums/admin/index"),
               meta: { title: "用户管理", icon: "ums-admin" }
             },
             {
               path: "role",
               name: "role",
               component: () => import("@/views/ums/role/index"),
               meta: { title: "角色列表", icon: "ums-role" }
             },
             {
               path: "allocMenu",
               name: "allocMenu",
               component: () => import("@/views/ums/role/allocMenu"),
               meta: {
                 title: "分配菜单",
                 activeMenu: "/ums/role",
                 noCache: true
               },
               hidden: true
             },
             {
               path: "allocResource",
               name: "allocResource",
               component: () => import("@/views/ums/role/allocResource"),
               meta: { title: "分配资源" },
               hidden: true
             },
             {
               path: "menu",
               name: "menu",
               component: () => import("@/views/ums/menu/index"),
               meta: { title: "菜单列表", icon: "ums-menu" }
             },
             {
               path: "addMenu",
               name: "addMenu",
               component: () => import("@/views/ums/menu/add"),
               meta: {
                 title: "添加菜单",
                 activeMenu: "/ums/menu",
                 noCache: true
               },
               hidden: true
             },
             {
               path: "updateMenu",
               name: "updateMenu",
               component: () => import("@/views/ums/menu/update"),
               meta: {
                 title: "修改菜单",
                 activeMenu: "/ums/menu",
                 noCache: true
               },
               hidden: true
             },
             {
               path: "resource",
               name: "resource",
               component: () => import("@/views/ums/resource/index"),
               meta: { title: "资源列表", icon: "ums-resource" }
             },
             {
               path: "assignmentList",
               name: "assignmentList",
               component: () => import("@/views/ums/assignmentList/list.vue"),
               meta: { title: "分配列表", icon: "ums-assignment-list" }
             },
             {
               path: "resourceCategory",
               name: "resourceCategory",
               component: () => import("@/views/ums/resource/categoryList"),
               meta: { title: "资源分类" },
               hidden: true
             }
           ]
         },
         {
           path: "/fms",
           name: "fms",
           meta: { title: "财务管理", icon: "" },
           component: Layout,
           alwaysShow: true,
           // redirect: '/cbs/wallet',
           children: [
             {
               path: "receiptManage",
               name: "receiptManage",
               component: () => import("@/views/fms/receiptManage/index"),
               meta: { title: "开票管理", icon: "" }
             },
             {
               path: "refundAudit",
               name: "refundAudit",
               component: () => import("@/views/fms/refundAudit/index"),
               meta: { title: "退款审核（财务）", icon: "",  }
             },
             {
               path: "refundAuditSale",
               name: "refundAuditSale",
               component: () => import("@/views/fms/refundAuditSale/index"),
               meta: { title: "退款审核（销售）", icon: "",  }
             },
             {
               path: "receiptConfirm",
               name: "receiptConfirm",
               component: () => import("@/views/fms/receiptConfirm/index"),
               meta: { title: "开票确认", icon: "", }
             },
             {
               path: "refund",
               name: "refund",
               component: () => import("@/views/fms/refund/index"),
               meta: { title: "订单变更明细", icon: "" }
             },
             {
               path: "rebateWithdrawManagement",
               name: "rebateWithdrawManagement",
               component: () =>
                 import("@/views/fms/rebate/withdrawManagement/index.vue"),
               meta: { title: "返利提现管理", icon: "", noCache: true }
             },
             {
               path: "payables",
               name: "payables",
               component: () => import("@/views/fms/payables/index"),
               meta: { title: "应付管理", icon: "" }
             },
             {
               path: "paymentManagement",
               name: "paymentManagement",
               component: () => import("@/views/fms/paymentManagement/index"),
               meta: { title: "到款管理", icon: "" }
             },
             {
               path: "paymentApply",
               name: "paymentApply",
               component: () => import("@/views/fms/paymentApply/index"),
               meta: { title: "到款申领", icon: "" }
             },
             {
               path: "balanceApplyRecord",
               name: "balanceApplyRecord",
               component: () => import("@/views/fms/balance/index"),
               meta: { title: "预存列表", icon: "" }
             },
             {
               path: "saleGuarantee",
               name: "saleGuarantee",
               component: () => import("@/views/fms/saleGuarantee/index"),
               meta: { title: "销售担保设置", icon: "" }
             }
           ]
         },
         {
           path: "/cms",
           component: Layout,
           name: "cms",
           meta: { title: "客户管理", icon: "" },
           alwaysShow: true,
           redirect: "/cms/member",
           children: [
             {
               path: "review",
               name: "review",
               component: () => import("@/views/cms/review/index"),
               meta: { title: "审核列表", icon: "" }
             },
             {
               path: "member",
               name: "member",
               component: () => import("@/views/cms/member/index"),
               meta: { title: "客户管理", icon: "" }
             },
             {
               hidden: true,
               path: "details",
               name: "memberDetails",
               component: () => import("@/views/cms/member/details/index"),
               meta: {
                 title: "操作详情",
                 icon: "",
                 activeMenu: "/cms/member",
                 noCache: true
               }
             },
             {
               path: "notActivateUser",
               name: "notActivateUser",
               component: () => import("@/views/cms/notActivateUser/index"),
               meta: { title: "待激活用户", icon: "" }
             },
             {
               path: "feedback",
               name: "feedback",
               component: () => import("@/views/cms/feedback/index"),
               meta: { title: "意见反馈", icon: "" }
             }
           ]
         },
         {
           path: "/opms",
           name: "opms",
           meta: { title: "运营中心", icon: "" },
           component: Layout,
           alwaysShow: true,
           redirect: "/opms/rebateAllocation",
           children: [
             {
               path: "coupon",
               name: "coupon",
               component: () => import("@/views/opms/coupon/index"),
               meta: { title: "优惠券", icon: "" }
             },
             {
               path: "rebateAllocation",
               name: "rebateAllocation",
               component: () => import("@/views/opms/rebate/index.vue"),
               meta: { title: "返利管理", icon: "", noCache: true }
             },
             {
               path: "pointExManage",
               name: "pointExManage",
               component: () => import("@/views/opms/pointExManage/index.vue"),
               meta: { title: "积分兑换管理", icon: "" }
             },
             {
               path: "pointExChange",
               name: "pointExChange",
               component: () => import("@/views/opms/pointExChange/index.vue"),
               meta: { title: "积分变更管理", icon: "" }
             },
             {
               path: "memberManage",
               name: "memberManage",
               component: () => import("@/views/opms/memberManage/index"),
               meta: { title: "会员管理", icon: "" }
             },
             {
               path: "lotteryManage",
               name: "lotteryManage",
               component: () => import("@/views/opms/lotteryManage/index"),
               meta: { title: "抽奖管理", icon: "" }
             },
             {
               path: "prestoredConfig",
               name: "prestoredConfig",
               component: () => import("@/views/opms/prestoredConfig/index"),
               meta: { title: "预存配置", icon: "" }
             },
             {
               path: "researchLib",
               name: "researchLib",
               component: () => import("@/views/opms/researchLib/index"),
               meta: { title: "科研文库", icon: "" }
             },
             {
               hidden: true,
               path: "researchLibDetail",
               name: "researchLibDetail",
               component: () =>
                 import("@/views/opms/researchLib/researchLibDetail/index"),
               meta: { title: "科研文库详情", icon: "" }
             },{
               path: 'discountList',
               name: 'discountList',
               component: () => import('@/views/opms/discountList/index'),
               meta: {title: '仪器折扣', icon: ''},
             }
           ]
         },
         {
           path: "/cbs",
           component: Layout,
           redirect: "/cbs/agency",
           name: "cbs",
           alwaysShow: true,
           meta: { title: "", icon: "" },
           children: [
             {
               path: "agency",
               name: "agency",
               component: () => import("@/views/cbs/agency/index"),
               meta: { title: "办事处管理", icon: "" }
             },
             {
               path: "agencyRemark",
               name: "agencyRemark",
               component: () => import("@/views/cbs/agency/agencyRemark"),
               meta: { title: "办事处说明", icon: "" }
             }
           ]
         },
         {
           path: "/unms",
           component: Layout,
           name: "unms",
           meta: { title: "高校管理", icon: "" },
           alwaysShow: true,
           redirect: "/unms/sample",
           children: [
             {
               path: "collegeLibrary",
               name: "collegeLibrary",
               component: () => import("@/views/unms/collegeLibrary/index"),
               meta: { title: "高校库", icon: "" }
             },
             {
               path: "sample",
               name: "sample",
               component: () => import("@/views/unms/sample/index"),
               meta: { title: "取样管理", icon: "" }
             }
           ]
         },
         /*  {
    path: '/cbs',
    name: 'device',
    redirect: '/cbs/deviceList',
    component: Layout,
    meta: {title: '', icon: 'product-list'},
    children: [{
      path: 'deviceList',
      name: 'device',
      component: () => import('@/views/material/deviceList'),
      meta: {title: '材料测试配置', icon: 'product-list'}
    }, {
      hidden: true,
      path: 'detail',
      name: 'ddd2',
      component: () => import('@/views/material/deviceDetail'),
      meta: {title: '材料详情', icon: '',activeMenu: '/cbs/deviceList'},
    }
    ]
  },*/
  {
    path: '/rms',
    component: Layout,
    redirect: '/rms/requirement',
    name: 'rms',
    alwaysShow: false,
    meta: {title: '', icon: ''},
    children: [{
      path: 'requirement',
      name: 'requirement',
      component: () => import('@/views/rms/requirement/index'),
      meta: {title: '需求列表', icon: ''}
    }]
  },
  {
    path: '/oms',
    component: Layout,
    name: 'oms',
    meta: {title: '订单管理', icon: ''},
    alwaysShow: true,
    redirect: '/oms/orderController',
    children: [{
      path: 'orderController',
      name: 'orderController',
      component: () => import('@/views/oms/orderController/index'),
      meta: {title: '订单管理', icon: ''}
    }, {
      path: 'saleorderController',
      name: 'saleorderController',
      component: () => import('@/views/oms/saleorderController/index'),
      meta: {title: '订单管理(销售)'}
    }, {
      path: 'orderReport',
      name: 'orderReport',
      component: () => import('@/views/oms/orderReport/index'),
      meta: {title: '待上传报告订单', icon: ''}
    }, {
      path: 'sampleStatus',
      name: 'sampleStatus',
      component: () => import('@/views/oms/sampleStatus/index'),
      meta: {title: '样品状态', icon: ''}
    }, {
      hidden: true,
      path: 'orderDetails',
      component: () => import('@/views/oms/orderDetails/index'),
      meta: {title: '订单详情', activeMenu: '/oms/orderController',noCache:true},
      name: "orderDetails"
    },{
      path: 'afterSaleOrderList',
      name: 'afterSaleOrderList',
      component: () => import('@/views/oms/afterSaleOrderList/index'),
      meta: {title: '售后订单', icon: ''}
    },{
      path: 'saleAfterSaleOrderList',
      name: 'saleAfterSaleOrderList',
      component: () => import('@/views/oms/afterSaleOrderList/index'),
      meta: {title: '售后订单(销售)', icon: ''}
    },{
      path: 'assignProviderOrder',
      component: () => import('@/views/oms/assignProvider/index'),
      meta: {title: '待分配供应商'},
      name: "assignProviderOrder"
    },{
      hidden: true,
      path: "orderChangeRecordDetail",
      name: "orderChangeRecordDetail",
      component: () => import('@/views/oms/orderChangeDetail/orderChangeRecordDetail/index'),
      meta: {title: '订单变更详情', icon: ''},
    }, {
      hidden: true,
      path: "orderChangeVerifyDetail",
      name: "orderChangeVerifyDetail",
      component: () => import('@/views/oms/orderChangeDetail/orderChangeVerifyDetail/index'),
      meta: {title: '订单变更审核详情', icon: ''},
    }, {
      path: 'orderChangeVerify',
      name: 'orderChangeVerify',
      component: () => import('@/views/oms/orderChangeVerify/index'),
      meta: {title: '订单变更审核'}
    },{
      path: 'orderEvaluate',
      name: 'orderEvaluate',
      component: () => import('@/views/oms/orderEvaluate/index'),
      meta: {title: '订单管理', icon: ''}
    },{
      path: 'reportApproval',
      name: 'reportApproval',
      component: () => import('@/views/oms/reportApproval/index'),
      meta: {title: '报告审核', icon: ''}
    },{
      path: 'saleGuaranteeList',
      name: 'saleGuaranteeList',
      component: () => import('@/views/oms/saleGuaranteeList/index'),
      meta: {title: '担保额度列表', icon: ''}
    },{
      path: 'saleGuaranteeOrder',
      name: 'saleGuaranteeOrder',
      component: () => import('@/views/oms/saleGuaranteeOrder/index'),
      meta: {title: '超额担保订单审核', icon: ''}
    }]
  },
  {
    path: '/plm',
    component: Layout,
    name: 'plm',
    alwaysShow:true,
    meta: {title: '产品库管理', icon: ''},
    children: [
      // {
      //   path: 'deviceCatogries',
      //   name: 'deviceCatogries',
      //   component: () => import('@/views/plm/deviceCatogries/index'),
      //   meta: {title: '仪器类别管理', icon: ''}
      // },
      {
        path: 'cloudDeviceList',
        name: 'cloudDeviceList',
        component: () => import('@/views/plm/material/cloudDeviceList'),
        meta: {title: '云现场', icon: 'product-list'}
      },
      // {
      //   hidden: true,
      //   path: 'cloudDetail',
      //   name: 'cloudDetail',
      //   component: () => import('@/views/plm/material/deviceDetail'),
      //   meta: {title: '云现场详情', icon: '',activeMenu: '/plm/cloudDeviceList',noCache: true},
      // },
      {
        path: 'deviceList',
        name: 'deviceList',
        component: () => import('@/views/plm/material/device'),
        meta: {title: '材料测试', icon: 'product-list'}
      },
      // {
      //   hidden: true,
      //   path: 'detail',
      //   name: 'ddd2',
      //   component: () => import('@/views/plm/material/deviceDetail'),
      //   meta: {title: '材料详情', icon: '',activeMenu: '/plm/deviceList',noCache: true},
      // },
      {
        path: 'analysisDeviceList',
        name: 'analysisDeviceList',
        component: () => import('@/views/plm/material/analysisDeviceList'),
        meta: {title: '成分分析', icon: 'product-list'}
      },
      
      
      {
        path: 'bigDevice',
        name: 'bigDevice',
        component: () => import('@/views/plm/bigDevice/index'),
        meta: { title: '大仪网配置', icon: 'product-list' }
      },
      
      
      
      {
        path: 'biologyDeviceList',
        name: 'biologyDeviceList',
        component: () => import('@/views/plm/material/biologyDeviceList'),
        meta: {title: '生物测试', icon: 'product-list'}
      },{
        path: 'evnDeviceList',
        name: 'evnDeviceList',
        component: () => import('@/views/plm/material/evnDeviceList'),
        meta: {title: '环境监测', icon: 'product-list'}
      },{
        path: 'serviceDeviceList',
        name: 'serviceDeviceList',
        component: () => import('@/views/plm/material/serviceDeviceList'),
        meta: {title: '特色服务', icon: 'product-list'}
      },{
        path: 'advanceBanner',
        name: 'advanceBanner',
        component: () => import('@/views/plm/material/advanceBanner'),
        meta: {title: '预告图片', icon: 'product-list'}
      },
      // {
      //   hidden: true,
      //   path: 'analysisDetail',
      //   name: 'analysisDetail',
      //   component: () => import('@/views/plm/material/deviceDetail'),
      //   meta: {title: '成分分析详情', icon: '',activeMenu: '/plm/analysisDeviceList',noCache: true},
      // }
    ]
  },
  {
    path: '/pms',
    component: Layout,
    name: 'pms',
    meta: {title: '订单管理', icon: ''},
    alwaysShow: true,
    redirect: '/pms/provider',
    children: [{
      path: 'provider',
      name: 'provider',
      component: () => import('@/views/pms/provider/index'),
      meta: {title: '供应商管理', icon: ''}
    }, {
      hidden: true,
      path: 'handleProvider',
      component: () => import('@/views/pms/handleProvider/index'),
      meta: {title: '供应商详情', activeMenu: '/pms/provider',noCache: true},
      name: "handleProvider"
    }, {
      path: 'providerApplyLog',
      name: 'providerApplyLog',
      component: () => import('@/views/pms/providerApplyLog/index'),
      meta: {title: '供应商管理', icon: ''}
    }, {
      path: 'financeApply',
      name: 'financeApply',
      component: () => import('@/views/pms/financeApply/index'),
      meta: {title: '结算申请', icon: ''}
    },
    //   {
    //   hidden: true,
    //   path: 'handleProvider',
    //   component: () => import('@/views/pms/provider/handleProvider'),
    //   meta: {title: '供应商详情', activeMenu: '/cbs/providerlist'},
    //   name: "handleProvider"
    // },
    ]
  },
  {
    path: '/gcm', //general configuration
    component: Layout,
    name: 'gcm',
    meta: {title: '通用设置', icon: ''},
    alwaysShow: true,
    redirect: '/gcm/listReminder',
    children: [
      {
        path: 'listReminder',
        name: 'listReminder',
        component: () => import('@/views/gcm/listReminder/index'),
        meta: {title: '列表提醒设置', icon: ''}
      },
      {
        path: 'systemConfig',
        name: 'systemConfig',
        component: () => import('@/views/gcm/systemConfig/index'),
        meta: {title: '系统设置', icon: ''}
      },
      {
        path: 'receiptBackConfig',
        name: 'receiptBackConfig',
        component: () => import('@/views/gcm/receiptBackConfig/index'),
        meta: {title: '系统设置', icon: ''}
      },
      {
        path: 'monitorLog',
        name: 'monitorLog',
        component: () => import('@weipu/element-ui-component/packages/monitorLog/index'),
        meta: {title: '系统日志', icon: ''}
      },
    ]
  },

]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js